import { initDataType } from '../types/initDataTypes.ts'
import { composeHeaderParameter } from '../utils/paramHelper.ts'

export type AssistantClientType = {
  getCookie: () => Promise<void>
}

export class AssistantClient implements AssistantClientType {
  constructor(
    private readonly endpoint: string,
    private readonly initData: initDataType
  ) {}

  public async getCookie() {
    const headers = composeHeaderParameter(this.initData)

    try {
      await fetch(`${this.endpoint}cookie`, {
        method: 'GET',
        credentials: 'include',
        headers: headers
      })
    } catch (e) {
      console.error(e)
    }
  }
}
